<template>
  <div :class="$utilModalStyle.modalOverlay" @click="props.closeModal">
    <div :class="[$utilModalStyle.modalContent, $style.missingVotesModalContent]" @click.stop>
      <div :class="$style.container">
        <div :class="[$pgCTStyle.headerContainer, $style.headerContainer]">
          <div :class="[$pgCTStyle.title, $style.title]">{{ $t('players-not-voted') }}</div>
          <div :class="$pgCTStyle.currentCount">
            {{ totalVoteNotCastedCount }}
            <!-- <span class="allowed-count">/{{ allowedPlayers }}</span> -->
          </div>
        </div>
        <div :class="[$pgCTStyle.bodyContainer, $style.bodyContainer]">
          <div :class="$groupedPlayersStyle.group" v-for="(group, index) in notVotedGroups" :key="index">
            <div :class="$groupedPlayersStyle.groupHeader">
              <div :class="$groupedPlayersStyle.groupName">{{ group.name }}</div>
              <!-- <div :class="$style.currentGroupCount">
                {{ group.voteNotCastedCount }}
                <span :class="$style.allowedGroupCount">/{{ groupLimit }}</span>
              </div> -->
            </div>
            <div :class="$groupedPlayersStyle.groupPlayers" v-for="player in group.notVotedPlayers" :key="player.id">
              <div :class="$groupedPlayersStyle.player">
                <div :class="$groupedPlayersStyle.avatarBox">
                  <img :src="player.avatar || defaultAvatar" alt="Avatar" :class="$groupedPlayersStyle.avatar" />
                </div>
                <div :class="$groupedPlayersStyle.name">{{ player.username }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.modalQuestion">
        {{ $t('players-not-voted-desc') }}
      </div>
      <div :class="$utilModalStyle.modalActions">
        <button :class="$utilModalStyle.secondaryAction" @click="props.closeModal">{{ $t('wait') }}</button>
        <button :class="$utilModalStyle.primaryAction" @click="handleProceed">{{ $t('proceed') }}</button>
      </div>
      <div :class="$utilModalStyle.modalHelperText">
        <span>{{ $t('note') }}:</span> {{ $t('auto-proceed-helper') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import styles from "@/css/MissingVotesModal.module.css";
import groupedPlayersStyles from "@/css/GroupedPlayersBox.module.css";
import utilModalStyles from "@/css/UtilModal.module.css";
import playGameComponentsTemplateStyles from "@/css/PlayGameComponentsTemplate.module.css";
import { defaultAvatar } from "@/utils/data";
import { computed } from "vue";

const $style = styles;
const $groupedPlayersStyle = groupedPlayersStyles;
const $utilModalStyle = utilModalStyles;
const $pgCTStyle = playGameComponentsTemplateStyles;

// eslint-disable-next-line
const props = defineProps({
  closeModal: {
    type: Function,
    required: true,
    default: () => {},
  },
  proceedNext: {
    type: Function,
    required: true,
    default: () => {},
  },
  groups: {
    type: Array,
    required: true,
  },
});

const totalVoteNotCastedCount = computed(
  () => props.groups?.reduce((sum, g) => sum + (g?.voteNotCastedCount || 0), 0) ?? 0
);

const notVotedGroups = computed(
  () => props.groups?.filter((g) => g?.voteNotCastedCount && g.voteNotCastedCount > 0)
)

function handleProceed() {
  props.closeModal();
  props.proceedNext();
}
</script>

<style scoped></style>
